import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { userSettingsAPIUrls } from '../data';
import { User } from '../types';

export const deleteUser = withLogger(
  async (uuid: User['uuid']): Promise<true> => {
    const url = `${userSettingsAPIUrls.delete}/${uuid}`;
    await authServiceAxiosClient.patch(url); //this s the line 10
    return true;
  },
);
